import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCategories,
  saveCategory,
} from "../../../redux/slices/categorySlice";
import {
  fetchFeatures,
  startImpersonation,
} from "../../../redux/slices/appSlice";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Button,
} from "@mui/material";
import {
  StyledButton,
  StyledContainer,
  StyledTableCell,
  ButtonGroup,
  SuspendButton,
} from "../../CSS/Styles";
import { fetchLanguages } from "../../../redux/slices/superAdmin/languagesSlice";
import { styled } from "@mui/material/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PeopleIcon from "@mui/icons-material/People";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AddIcon from "@mui/icons-material/Add";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  setPageLoadingFalse,
  setPageLoadingTrue,
} from "../../../redux/slices/appSlice";
import { fetchCompanies } from "../../../redux/slices/superAdmin/companiesSlice";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const data = [
  {
    id: 1,
    company: "Company A",
    category: "News",
    creationDate: "2024-01-01",
    subscriptionEndDate: "2026-01-02",
  },
  {
    id: 2,
    company: "Company B",
    category: "Wedding",
    creationDate: "2024-01-02",
    subscriptionEndDate: "2027-01-02",
  },
];

const usersData = [
  {
    id: 1,
    name: "John Doe",
    email: "john@company.com",
    phone: "123-456-7890",
    privilege: "Read",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@company.com",
    phone: "987-654-3210",
    privilege: "Write",
  },
];

export default function Companies() {
  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.categories);
  const { companies } = useSelector((state) => state.companies);

  useEffect(() => {
    if (categories === null) {
      dispatch(fetchCategories());
    }
  }, [dispatch, categories]);

  useEffect(() => {
    if (!companies || companies.length === 0) {
      dispatch(fetchCompanies());
    }
  }, [dispatch, companies]);

  useEffect(() => {
    if (companies === null) {
      dispatch(fetchCompanies());
    }
  }, [dispatch, companies]);

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [isUsersView, setIsUsersView] = useState(false);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [newUser, setNewUser] = useState({
    name: "",
    email: "",
    phone: "",
    privilege: "",
  });

  const [openAddCompanyModal, setOpenAddCompanyModal] = useState(false);
  const [newCompany, setNewCompany] = useState({
    name: "",
    category: "",
    attachmentPath: "",
  });

  const handleOpenAddCompanyModal = () => {
    setOpenAddCompanyModal(true);
  };

  const handleCloseAddCompanyModal = () => {
    setOpenAddCompanyModal(false);
    setNewCompany({ name: "", category: "", attachmentPath: "" });
  };

  const handleFileChange = (event, type) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      if (type === "logo") {
        setNewCompany({ ...newCompany, logo: files[0] });
      } else if (type === "attachments") {
        setNewCompany({ ...newCompany, attachments: [...files] });
      }
    }
  };

  const handleFileUpload = async () => {
    if (selectedFiles.length === 0) {
      return;
    }

    const formData = new FormData();

    Array.from(selectedFiles).forEach((file) => {
      formData.append("gallery[]", file);
    });

    try {
      dispatch(setPageLoadingTrue());
      const response = await axios.post(
        "/path/to/your/php/upload-gallery.php",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
    } catch (error) {
      console.error("Error uploading files:", error);
    } finally {
      dispatch(setPageLoadingFalse());
    }
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formData.append("name", newCompany.name);
    formData.append("phone", newCompany.phone);
    formData.append("email", newCompany.email);
    formData.append("defaultLanguage", newCompany.defaultLanguage);
    formData.append("facebook", newCompany.facebook);
    formData.append("instagram", newCompany.instagram);
    formData.append("whatsapp", newCompany.whatsapp);
    formData.append("twitter", newCompany.twitter);
    formData.append("websiteTitle", newCompany.websiteTitle);
    formData.append("websiteTags", newCompany.websiteTags);
    formData.append("websiteDescription", newCompany.websiteDescription);
    formData.append("startSubscriptionDate", newCompany.startSubscriptionDate);
    formData.append("endSubscriptionDate", newCompany.endSubscriptionDate);

    if (newCompany.logo) {
      formData.append("logo", newCompany.logo);
    }
    if (newCompany.attachments.length > 0) {
      newCompany.attachments.forEach((file, index) => {
        formData.append(`attachment_${index}`, file);
      });
    }

    try {
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const handleImpersonate = (id) => {
    dispatch(fetchLanguages({ id }));
    dispatch(startImpersonation(id));
    localStorage.setItem("companyId", id);
    dispatch(fetchFeatures());
  };

  const handleEditUser = (id) => {
    alert(`Editing ID: ${id}`);
  };

  const handleUsers = (id) => {
    setSelectedCompany(id);
    setIsUsersView(true);
  };

  const handleConfigure = (id) => {
    alert(`Configuring company ID: ${id}`);
  };

  const handleSuspend = (id) => {
    alert(`Suspending company ID: ${id}`);
  };

  const handleAddUser = () => {
    setOpenModal(true);
  };

  const handleSaveUser = () => {
    alert(`User added: ${newUser.name}`);
    setOpenModal(false);
  };

  const handleBackToCompanies = () => {
    setIsUsersView(false);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCompanyInputChange = (e) => {
    const { name, value } = e.target;
    setNewCompany((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  if (isUsersView) {
    const handleDeleteUser = (id) => {
      // // Confirm deletion
      // if (window.confirm('Are you sure you want to delete this user?')) {
      //   // Remove the user with the given id
      //   setUsersData((prevData) => prevData.filter((user) => user.id !== id));
      // }
    };
    return (
      <StyledContainer>
        <Paper elevation={3} sx={{ padding: 3 }}>
          <Box display="flex" alignItems="center" mb={2}>
            <IconButton onClick={handleBackToCompanies}>
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h5" sx={{ marginLeft: 1 }}>
              Users for Company {selectedCompany}
            </Typography>
          </Box>

          <StyledButton
            sx={{ marginBottom: 2, fontSize: "12px", padding: "8px 16px" }}
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleAddUser}
          >
            Add User
          </StyledButton>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell>Name</StyledTableCell>
                  <StyledTableCell>Email</StyledTableCell>
                  <StyledTableCell>Phone Number</StyledTableCell>
                  <StyledTableCell>Privilege</StyledTableCell>
                  <StyledTableCell>Actions</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {usersData.map((user) => (
                  <TableRow hover key={user.id} style={{ padding: "10px 0" }}>
                    <TableCell>{user.name}</TableCell>
                    <TableCell>{user.email}</TableCell>
                    <TableCell>{user.phone}</TableCell>
                    <TableCell>{user.privilege}</TableCell>
                    <TableCell>
                      <div style={{ display: "flex", gap: "10px" }}>
                        <StyledButton
                          variant="outlined"
                          startIcon={<EditIcon />}
                          onClick={() => handleEditUser(user.id)}
                        >
                          Edit
                        </StyledButton>
                        <SuspendButton
                          variant="outlined"
                          startIcon={<DeleteIcon />}
                          onClick={() => handleDeleteUser(user.id)}
                        >
                          Delete
                        </SuspendButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <Dialog open={openModal} onClose={handleCloseModal}>
          <DialogTitle>
            <IconButton edge="start" color="inherit" onClick={handleCloseModal}>
              <ArrowBackIcon />
            </IconButton>
            Add New User
          </DialogTitle>
          <DialogContent>
            <TextField
              label="Name"
              name="name"
              value={newUser.name}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Email"
              name="email"
              value={newUser.email}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Phone"
              name="phone"
              value={newUser.phone}
              onChange={handleInputChange}
              fullWidth
              margin="normal"
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Privilege</InputLabel>
              <Select
                name="privilege"
                value={newUser.privilege}
                onChange={handleInputChange}
                label="Privilege"
              >
                <MenuItem value="Read">Read</MenuItem>
                <MenuItem value="Write">Write</MenuItem>
                <MenuItem value="Admin">Admin</MenuItem>
              </Select>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <StyledButton
              onClick={handleCloseModal}
              style={{ backgroundColor: "red", color: "#fff" }}
            >
              Cancel
            </StyledButton>
            <StyledButton
              onClick={handleSaveUser}
              style={{ backgroundColor: "#1E243E", color: "#fff" }}
            >
              Save
            </StyledButton>
          </DialogActions>
        </Dialog>
      </StyledContainer>
    );
  }

  return (
    <StyledContainer>
      <Paper elevation={3} sx={{ padding: 3 }}>
        <Box display="flex" justifyContent="flex-start" mb={2}>
          <StyledButton
            sx={{ marginBottom: 2, fontSize: "14px", padding: "8px 16px" }}
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={handleOpenAddCompanyModal}
          >
            Add Company
          </StyledButton>
        </Box>
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledTableCell>Company</StyledTableCell>
                <StyledTableCell>Owner</StyledTableCell>
                <StyledTableCell>Creation Date</StyledTableCell>
                <StyledTableCell align="right">Actions</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {companies.map((row) => (
                <TableRow key={row.id}>
                  <TableCell>{row.company_name}</TableCell>
                  <TableCell>{row.owner_name}</TableCell>
                  <TableCell>{row.creation_date}</TableCell>
                  <TableCell align="right">
                    <ButtonGroup>
                      <StyledButton
                        variant="outlined"
                        startIcon={<AccountBoxIcon />}
                        onClick={() => handleImpersonate(row.id)}
                      >
                        Impersonate
                      </StyledButton>
                      <SuspendButton
                        variant="outlined"
                        startIcon={<DeleteIcon />}
                        onClick={() => handleSuspend(row.id)}
                      >
                        Suspend
                      </SuspendButton>
                    </ButtonGroup>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Dialog
        open={openAddCompanyModal}
        onClose={handleCloseAddCompanyModal}
        fullScreen
      >
        <DialogTitle>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseAddCompanyModal}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          Add Company
        </DialogTitle>
        <DialogContent>
          {/* Section 1: Company Information */}
          <Typography variant="h6" gutterBottom>
            Company Information
          </Typography>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              label="Company Name"
              name="name"
              value={newCompany.name}
              onChange={handleCompanyInputChange}
              fullWidth
            />
            <TextField
              label="Phone"
              name="phone"
              value={newCompany.phone}
              onChange={handleCompanyInputChange}
              fullWidth
            />
            <TextField
              label="Email"
              name="email"
              value={newCompany.email}
              onChange={handleCompanyInputChange}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel>Default Language</InputLabel>
              <Select
                name="defaultLanguage"
                value={newCompany.defaultLanguage}
                onChange={handleCompanyInputChange}
              >
                <MenuItem value="English">English</MenuItem>
                <MenuItem value="French">French</MenuItem>
                <MenuItem value="Arabic">Arabic</MenuItem>
              </Select>
            </FormControl>
            <TextField
              label="Facebook"
              name="facebook"
              value={newCompany.facebook}
              onChange={handleCompanyInputChange}
              fullWidth
            />
            <TextField
              label="Instagram"
              name="instagram"
              value={newCompany.instagram}
              onChange={handleCompanyInputChange}
              fullWidth
            />
            <TextField
              label="WhatsApp"
              name="whatsapp"
              value={newCompany.whatsapp}
              onChange={handleCompanyInputChange}
              fullWidth
            />
            <TextField
              label="Twitter"
              name="twitter"
              value={newCompany.twitter}
              onChange={handleCompanyInputChange}
              fullWidth
            />
          </Box>

          {/* Section 2: SEO Information */}
          <Box mt={4}>
            <Typography variant="h6" gutterBottom>
              SEO Information
            </Typography>
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                label="Website Title"
                name="websiteTitle"
                value={newCompany.websiteTitle}
                onChange={handleCompanyInputChange}
                fullWidth
              />
              <TextField
                label="Website Tags"
                name="websiteTags"
                value={newCompany.websiteTags}
                onChange={handleCompanyInputChange}
                fullWidth
              />
              <TextField
                label="Website Description"
                name="websiteDescription"
                value={newCompany.websiteDescription}
                onChange={handleCompanyInputChange}
                fullWidth
                multiline
                rows={4}
              />
            </Box>
          </Box>

          {/* Section 3: Subscription */}
          <Box mt={4}>
            <Typography variant="h6" gutterBottom>
              Subscription
            </Typography>
            <Box display="flex" flexDirection="column" gap={2}>
              <TextField
                label="Start Subscription Date"
                name="startSubscriptionDate"
                type="date"
                value={newCompany.startSubscriptionDate}
                onChange={handleCompanyInputChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="End Subscription Date"
                name="endSubscriptionDate"
                type="date"
                value={newCompany.endSubscriptionDate}
                onChange={handleCompanyInputChange}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          </Box>

          {/* Section 4: Attachments */}
          <Box mt={4}>
            <Typography variant="h6" gutterBottom>
              Attachments
            </Typography>
            <Box display="flex" flexDirection="column" gap={2}>
              <Button
                sx={{ backgroundColor: "#162036", mt: 1 }}
                component="label"
                variant="contained"
                startIcon={<CloudUploadIcon />}
              >
                Upload Logo
                <VisuallyHiddenInput
                  type="file"
                  onChange={(e) => handleFileChange(e, "logo")}
                />
              </Button>
              <Button
                sx={{ backgroundColor: "#162036", mt: 1 }}
                component="label"
                variant="contained"
                startIcon={<CloudUploadIcon />}
              >
                Upload Attachments
                <VisuallyHiddenInput
                  type="file"
                  onChange={(e) => handleFileChange(e, "attachments")}
                  multiple
                />
              </Button>
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <StyledButton
            onClick={handleCloseAddCompanyModal}
            sx={{ backgroundColor: "red", color: "#fff" }}
          >
            Cancel
          </StyledButton>
          <StyledButton
            onClick={handleSubmit}
            sx={{ backgroundColor: "#1E243E", color: "#fff" }}
          >
            Add
          </StyledButton>
        </DialogActions>
      </Dialog>
    </StyledContainer>
  );
}
